<template>
  <div class="header">
    <router-link to="/" class="logo"></router-link>
    <div class="right-func" v-if="isLogin">
      <router-link to="/admin/upload" class="upload" 
        ><i class="el-icon-upload2"></i>上传</router-link
      >
      <div class="header-user-menu" v-if="isLogin">
        <div class="header-user">
          <div class="header-user-menu-avatar"></div>
          <i class="el-icon-caret-bottom"></i>
        </div>

        <ul class="hover-menu">
          <li>
            <div class="user-name">{{username}}</div>
          </li>
          <li class="separator"></li>
          <li><router-link to="/admin/modellist">上传列表</router-link></li>
          <li><router-link to="/account">用户中心</router-link></li>
          <li><a @click="loginout()">退出登录</a></li>
          <!-- <li>
            <a href="https://sketchfab.com/bubblezww0527/models">Models</a>
          </li>
          <li>
            <a href="https://sketchfab.com/bubblezww0527/collections"
              >Collections</a
            >
          </li>
          <li><a href="https://sketchfab.com/bubblezww0527/likes">Likes</a></li> -->
          <!-- <li class="separator"></li> -->
        </ul>
      </div>
    </div>
    <div class="right-func" v-else>
      <router-link to="/login?id=1" class="login">登录</router-link>
      <router-link to="/login?id=2" class="register">注册</router-link>
      <router-link to="/login?id=1" class="upload"
        ><i class="el-icon-upload2"></i>上传</router-link
      >
    </div>
  </div>
</template>
<style scoped>
.header {
  height: 60px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: hsla(0, 4%, 39%, 0);
  /* background: transparent
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.1) 45%,
      transparent
    )
    no-repeat; */
  background: black;
  font-family: "Open Sans", sans-serif;
  z-index: 4;
}
.logo {
  height: 100%;
  width: 350px;
  display: block;
  background: url(../../public/imgs/common/logo.png) no-repeat 20px center;
  background-size: 80%;
  cursor: pointer;
}
.right-func {
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 30px;
  font-size: 14px;

  font-weight: 700;
}
.login {
  min-height: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  padding: 0 16px;
  letter-spacing: 2px;
  text-align: center;
  text-shadow: none;
  text-transform: uppercase;
  outline: none;
  color: hsla(0, 0%, 100%, 0.75);
  transition: color 0.25s ease;
  text-decoration: none;
  cursor: pointer;
}
.login:hover {
  color: #fff;
}

.register {
  min-height: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  margin-left: 20px;
  padding: 0 16px;
  background-color: #1caad9;
  transition: background-color 0.15s ease;
  border: 0;
  border-color: "";
  border-style: solid;
  border-radius: 4px;
  color: #fff;
  letter-spacing: 2px;
  text-align: center;
  text-shadow: none;
  text-transform: uppercase;
  text-decoration: none;
  outline: none;
  cursor: pointer;
}
.register:hover {
  background-color: #1c88bb;
}
.upload {
  min-height: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  margin-left: 20px;
  padding: 0 16px;
  color: #fff;
  background-color: #ff9e3a;
  transition: background-color 0.15s ease;
  border: 0;
  border-color: "";
  border-style: solid;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
}
.upload:hover {
  background-color: #ff8507;
}

.header-user-menu {
  height: 100%;
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  color: #eee;
}
.header-user {
  height: 100%;
  display: flex;
  align-items: center;
}
.header-user-menu-avatar {
  height: 32px;
  width: 32px;
  background: url(../../public/imgs/common/user.jpg) no-repeat center;
  background-size: contain;
}
.header-user-menu:hover {
  color: #1caad9;
}
.el-icon-caret-bottom {
  margin-left: 2px;
}
.hover-menu {
  width: 210px;
  min-width: 140px;
  position: absolute;
  right: -30px;
  top: 100%;
  left: auto;
  margin: 0;
  padding: 8px 0;
  overflow: visible;
  border-radius: 4px;
  box-shadow: 0 11px 20px 0 rgb(97 108 121 / 17%);
  background: #fff;
  opacity: 0;
  list-style-type: none;
  white-space: nowrap;
  visibility: hidden;
  transition: opacity 0.3s 0.2s, visibility 0s 0.5s;
  transform: translateZ(0);
  z-index: 1;
}
.header-user:hover + .hover-menu,
.hover-menu:hover {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s;
}
.user-name {
  width: 90%;
  margin: auto;
  color: #555;
  font-weight: 100;
}
.separator {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
}
.hover-menu > li {
  position: relative;
  line-height: 28px;
}
.hover-menu li a {
  display: flex;
  height: 28px;
  padding: 0 15px;
  line-height: 28px;
  align-items: center;
  color: #555;
  font-weight: 100;
  letter-spacing: 1px;
  cursor: pointer;
}
.hover-menu li a:hover {
  color: #fff;
  background: #1caad9;
}
</style>

<script>
import https from "../https.js";
import axios from "axios";
export default {
  name: "top",
  props: {
    // userNum: String
  },
  data() {
    return {
      isLogin: false,
      username:null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.username = window.sessionStorage.getItem("model_username");
      if (this.username == null) {
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }

      // https
      // .fetchGet('/api/User/UserInfo')
      // .then(res => {
      //   this.username = res.data.phoneNumber
      // })
    },
    loginout() {
      https.fetchGet("/api/User/Logout").then((res) => {
        console.log(res);
        this.$router.push({ path: "/login" });
      });
    },
    goHome() {
      this.$router.push({ path: "/my" });
    },
  },
};
</script>
